import React from 'react';
import styles from './inlineSpinner.module.scss';

interface InlineSpinnerProps {
    label?: string;
    color?: 'primary' | 'muted' | 'inverse';
}

const InlineSpinner: React.FC<InlineSpinnerProps> = ({
    label = 'Loading',
    color = 'primary',
}) => {
    const colorClass =
        color === 'inverse'
            ? styles.inverse
            : color === 'muted'
                ? styles.muted
                : styles.primary;

    return (
        <span
            className={`${styles.inlineSpinner} ${colorClass}`}
            role="status"
            aria-label={label}
            aria-live="polite"
        />
    );
};

export default InlineSpinner;
